import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";

export default function Results({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(-1);
  const navigate = useNavigate();

  const quizQuestions = gameQuestionsQuery.content.filter(
    (q) => q.mechanics === "Quiz"
  );

  const resultData = gameQuestionsQuery.content.find(
    (q) => q.mechanics === "Results"
  );

  const correctAnswers = resultData.correctAnswers;

  const correctCount = answers.reduce((count, ans) => {
    return correctAnswers[ans.question_ident] === ans.answer_ident
      ? count + 1
      : count;
  }, 0);

  const points = correctCount * 5;
  const canSpin = correctCount >= 6;

  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const handleNextButtonClick = async () => {
    if (canSpin) {
      try {
        await sendAnswers();
        navigate("/activities/birthdayglo_2025/gra");
      } catch (err) {
        console.error("Błąd przy wysyłaniu odpowiedzi:", err);
      }
      return;
    }

    sendAnswers();
    setCurrentQuestion(gameQuestionsQuery?.content.length + 1);
  };

  console.log(answers);

  return (
    <section
      className={`game-page quiz-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="content">
              <h2 className="main-copy">
                <strong>Du hast {correctCount} </strong>
                <br />
                von {quizQuestions.length} Fragen richtig
                <br /> beantwortet und{" "}
                <strong>{points} Punkte gesammelt.</strong>
              </h2>
              <br />
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(canSpin
                    ? "<strong>Damit hast du unser Glücksrad freigeschaltet</strong>  – jetzt hast du die Chance, einen Geburtstagsgewinn abzustauben!"
                    : `Leider hast du das <strong>Glücksrad</strong> diesmal nicht freigeschaltet – aber eine <strong>Geburtstagsüberraschung</strong> wartet trotzdem auf dich!`),
                }}
              ></p>
            </div>
            <div className={`content-list ${ident} `}>
              <p className="check">
                Schau dir unten <strong>deine Antworten</strong> an:
              </p>
              <div className="line" />
              <div className="numbered-questions-review">
                {quizQuestions.map((question, index) => {
                  const questionIdent = question.ident;
                  const correctAnswerIdent = correctAnswers[questionIdent];
                  const userAnswerIdent = answers.find(
                    (a) => a.question_ident === questionIdent
                  )?.answer_ident;

                  return (
                    <div key={questionIdent} className="question-review-block">
                      <p className="question-number">
                        {index + 1}.{" "}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(question.question),
                          }}
                        />
                      </p>
                      <ul className="answers-list">
                        {userAnswerIdent === correctAnswerIdent ? (
                          <li className="answer-item correct">
                            <strong>Richtige Antwort:</strong>{" "}
                            {
                              question.answers.find(
                                (a) => a.ident === correctAnswerIdent
                              )?.answer
                            }
                          </li>
                        ) : (
                          <>
                            <li className="answer-item correct">
                              <strong>Richtige Antwort:</strong>{" "}
                              {
                                question.answers.find(
                                  (a) => a.ident === correctAnswerIdent
                                )?.answer
                              }
                            </li>
                            <li className="answer-item wrong">
                              <strong>Deine Antwort:</strong>{" "}
                              {
                                question.answers.find(
                                  (a) => a.ident === userAnswerIdent
                                )?.answer
                              }
                            </li>
                          </>
                        )}
                      </ul>
                      <div className="separator-line" />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button action={handleNextButtonClick}>
                    {canSpin ? "Dreh jetzt am Rad!" : "Schau mal vorbei"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton action={handleNextButtonClick}>
          {canSpin ? "Dreh jetzt am Rad!" : "Schau mal vorbei"}
        </StickyButton>
      )}
    </section>
  );
}
